<script setup lang="ts">
const { t, locale } = useI18n()
</script>

<template>
  <div class="top-banner">
    <div class="image-container">
      <div v-if="locale === 'ko'" class="locale-group">
        <a
          href="https://forms.gle/5pmfxAVtGDPWmcCfA"
          target="_blank"
          title="New Tab"
        >
          <img
            class="mobile"
            src="../../assets/images/oulim/nova_bid_banner_ss6_mb.jpg"
            :alt="$t('auction.topBanner.alt')"
          />
          <img
            class="desktop"
            src="../../assets/images/oulim/nova_bid_banner_ss6_pc.jpg"
            :alt="$t('auction.topBanner.alt')"
          />
        </a>
      </div>
      <div v-else class="locale-group">
        <a
          href="https://forms.gle/5pmfxAVtGDPWmcCfA"
          target="_blank"
          title="New Tab"
        >
          <img
            class="mobile"
            src="../../assets/images/oulim/nova_bid_banner_ss6_mb_en.jpg"
            :alt="$t('auction.topBanner.alt')"
          />
          <img
            class="desktop"
            src="../../assets/images/oulim/nova_bid_banner_ss6_pc_en.jpg"
            :alt="$t('auction.topBanner.alt')"
          />
        </a>
      </div>
    </div>
    <p class="banner-text">
      {{ t('auction.topBanner.text') }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
.top-banner {
  position: relative;
  width: 100%;
  overflow: hidden;
  .image-container {
    @include mobile {
      border-radius: 0;
    }
    .locale-group {
      a {
        display: block;
        img {
          width: 100%;
          border-radius: 18px;
        }
        img.mobile {
          display: none;
        }
        @include mobile {
          img.desktop {
            display: none;
          }
          img.mobile {
            display: block;
            border-radius: 0px;
          }
        }
      }
    }
  }
  .banner-text {
    padding-top: 10px;
    color: $color-text-3;
    text-align: right;
    @include mobile {
      padding: 10px 15px 0 15px;
    }
  }
}
</style>
